import React, { type PropsWithChildren } from 'react';
import { ForbiddenPage } from '@bbkAdminComponents/forbidden.page';

export const LicenseGuard: React.FC<
  PropsWithChildren<{ allowed: boolean }>
> = ({ allowed, children }) => (allowed ? <>{children}</> : <ForbiddenPage />);
